import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-a7a95ac0"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "loading"
};

const _hoisted_2 = _createTextVNode("加载中...");

import { computed } from 'vue';
import { useStore } from 'vuex';
export default _defineComponent({
  __name: 'loading',

  setup(__props) {
    const store = useStore();
    const loading = computed(() => store.getters['common/loading']);
    return (_ctx, _cache) => {
      const _component_van_loading = _resolveComponent("van-loading");

      return _unref(loading) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_loading, {
        size: "50px",
        type: "spinner",
        vertical: ""
      }, {
        default: _withCtx(() => [_hoisted_2]),
        _: 1
      })])) : _createCommentVNode("", true);
    };
  }

});